import React from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import InvestorProfilePage from '../public/investorProfile/InvestorProfilePage';
import { useIsEmployee } from './useIsEmployee';

// "Fill in for investor" inside the dashboard (/kyc-queue/:mobile/fill?token=…): the
// investor's own form in assisted mode, in the normal content area, with a way back to
// the verification page. Everything saved is recorded under the staff member.
const AssistedFillPage: React.FC = () => {
    const { mobile = '' } = useParams();
    const navigate = useNavigate();
    const isEmployee = useIsEmployee();
    // Step back to the verification page this was opened from, so its own Back still
    // leads to the queue. Opened directly (no history here): replace with that page.
    const goBack = () => ((window.history.state?.idx ?? 0) > 0
        ? navigate(-1)
        : navigate(`/kyc-queue/${mobile}`, { replace: true }));
    // Employees only: anyone else opening this address goes to the verification page.
    if (!isEmployee) return <Navigate to={`/kyc-queue/${mobile}`} replace />;
    return (
        <div className="w-full">
            <div className="px-4 sm:px-6 pt-4">
                <button type="button" onClick={goBack}
                    className="h-9 pl-2 pr-3 rounded-lg ring-1 ring-slate-200 bg-white text-[13px] font-bold text-slate-700 inline-flex items-center gap-1.5 hover:bg-slate-50 hover:text-[#1B4332]">
                    <ArrowLeft size={16} />Back to verification
                </button>
            </div>
            <InvestorProfilePage embedded />
        </div>
    );
};

export default AssistedFillPage;
